import { FunctionComponent, useContext, useEffect, useState } from "react";
import { useTranslation } from "next-i18next/pages";
import { useInView } from "react-intersection-observer";
import AppContext from "context/AppContext";
import styles from "../../styles/home/Testimonial.module.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

interface Testimonial {
  author: string;
  comments: string[];
  position: string;
}

interface TestimonialProps {
  isDarkMode?: boolean;
  doAnimation?: boolean;
}

const Testimonial: FunctionComponent<TestimonialProps> = ({ isDarkMode = false, doAnimation = false }) => {
  const { isMobile } = useContext(AppContext);
  const { t } = useTranslation("common");
  const testimonials: Testimonial[] = t("testimonial.all", { returnObjects: true }) as Testimonial[];
  const testimonialCount = String(testimonials.length).padStart(2, "0");
  const [isAnimationOn, setIsAnimationOn] = useState<boolean>(false);
  const { ref, inView } = useInView({ rootMargin: "0% 0% -5%" });

  useEffect(() => {
    if (inView) {
      setIsAnimationOn(true);
    }
  }, [inView]);

  return (
    <section
      className={`${styles.testimonialContainer} ${isDarkMode ? styles.darkMode : ""}
                  ${isAnimationOn && !isMobile && doAnimation ? styles.animated : ""}`}
      ref={ref}>
      <div className={styles.header}>
        <div>
          <div className={styles.kicker}>{t("testimonial.kicker")}</div>
          <h3 className={styles.title}>{t("testimonial.title")}</h3>
        </div>
        <span className={styles.index}>01 — {testimonialCount}</span>
      </div>

      <div className={styles.main}>
        <Swiper loop={true} slidesPerView={1} spaceBetween={25} className="mySwiper"
          modules={[Pagination]}
          pagination={{ clickable: true,
            renderBullet: function (index: number, className: string) {
              return `<span class="${className}"></span>`;
            }}}>
          {
            testimonials.map((testimonial: Testimonial, index: number) => (

              <SwiperSlide key={index} className={`${styles.swiperSlide} ${styles.testimonial}`}>
                <div className={styles.rightSide}>
                  {
                    testimonial.comments.map((comment: string, i: number) => (
                      <p key={i} className={styles.comment}>{comment}</p>
                    ))
                  }
                  <div className={styles.authorInfo}>
                    <div className={styles.author}>{testimonial.author}</div>
                    <div className={styles.authorPosition}>{testimonial.position}</div>
                  </div>
                </div>
              </SwiperSlide>

            ))
          }
        </Swiper>
      </div>
    </section>
  );
};

export default Testimonial;
